<mat-card>
    <mat-card-header>
        <mat-card-title class="mat-card-title-custom">
            {{'sms_history_report.card_title' | translate}}
        </mat-card-title>
    </mat-card-header>
    <mat-card-content class="mb-3 mat-card-content-contract-sm">
        <!-- Filter -->
        <mat-accordion #accordion="matAccordion" [multi]="true">
            <mat-expansion-panel expanded="true" class="mt-3">
                <mat-expansion-panel-header>
                    <mat-panel-title class="mat-panel-title">
                        {{'report_components.filter_title' | translate}}
                    </mat-panel-title>
                </mat-expansion-panel-header>
                <form [formGroup]="form" class="pb-3">
                    <div class="row">
                        <!-- Thời gian lập (từ ngày) -->
                        <div class="col-md-6 col-12">
                            <mat-form-field class="w-100">
                                <mat-label>{{ 'total_contract_report.from_date' | translate }}</mat-label>
                                <input matInput [matDatepicker]="createdTimeFrom"
                                       name="fromDate" #pickerInput formControlName="fromDate"
                                       (dateChange)="changeDatePickerFromDate($event);"
                                       maxlength="200" (focus)="dateErr = 'toDate'" autocomplete="off" required/>
                                <mat-datepicker-toggle matSuffix [for]="createdTimeFrom">
                                    <i matDatepickerToggleIcon class="fa fa-calendar" aria-hidden="true" [matTooltip]="'enterprise_contract.tooltips.pick_date' | translate"></i>
                                </mat-datepicker-toggle>
                                <mat-datepicker #createdTimeFrom></mat-datepicker>
                                <mat-error *ngIf="formControls['fromDate'].invalid && (formControls['fromDate'].dirty || formControls['fromDate'].touched)">
                                      <span *ngIf="formControls['fromDate'].invalid">
                                        {{getErrorDateMessageRange(pickerInput.value)}}
                                      </span>
                                  <span *ngIf="getErrorDateMessageRange(pickerInput.value)==null">
                                        {{'validation.empty_of_date_consumption' | translate}}
                                      </span>
                                </mat-error>
                            </mat-form-field>
                        </div>

                        <!-- Thời gian lập (đến ngày) -->
                        <div class="col-md-6 col-12">
                            <mat-form-field class="w-100">
                                <mat-label>{{ 'total_contract_report.to_date' | translate }}</mat-label>
                                <input matInput [matDatepicker]="createdTimeToRef"
                                       (dateChange)="changeDatePickerToDate($event)"
                                       name="toDate" #pickerInput1 formControlName="toDate"
                                       maxlength="200" (focus)="dateErr = 'toDate'" autocomplete="off" required/>
                                <mat-datepicker-toggle matSuffix [for]="createdTimeToRef">
                                    <i matDatepickerToggleIcon class="fa fa-calendar" aria-hidden="true" [matTooltip]="'enterprise_contract.tooltips.pick_date' | translate"></i>
                                </mat-datepicker-toggle>
                                <mat-datepicker #createdTimeToRef></mat-datepicker>
                                <mat-error *ngIf="formControls['toDate'].invalid && (formControls['toDate'].dirty || formControls['toDate'].touched)">
                                    <span *ngIf="formControls['toDate'].invalid">
                                      {{getErrorDateMessageRange(pickerInput1.value)}}
                                    </span>
                                    <span *ngIf="getErrorDateMessageRange(pickerInput1.value)==null">
                                      {{'validation.empty_of_date_consumption' | translate}}
                                    </span>
                                </mat-error>
                            </mat-form-field>
                        </div>

                        <div class="offset-4 col-4"
                         *ngIf="isShowWarningSelectedFromDate">
                            <mat-error>
                                {{ 'search_form.limit_day_select_create_date' | translate }}
                            </mat-error>
                        </div>
                        <div class="offset-8 col-4"
                         *ngIf="isShowWarningSelectedToDate">
                            <mat-error>
                                {{ 'search_form.limit_day_select_create_date' | translate }}
                            </mat-error>
                        </div>
                    </div>
                </form>
            </mat-expansion-panel>
        </mat-accordion>
    </mat-card-content>
    <div class="row mt-3" style="margin-bottom: 15px;">
        <div class="col-lg-12 d-flex justify-content-center">
            <button mat-raised-button color="primary" (click)="onExportReport()"
                    [disabled]="!form.valid">
                <mat-icon class="mr-0" style="font-weight: 900;">receipt_long</mat-icon>
                {{'total_contract_report.title_btn' | translate}}
            </button>
        </div>
    </div>
</mat-card>
<app-history-report [mode]="mode" [formExport]="exportForm" (filterForm)="filterForm($event)"></app-history-report>

